import { SwipeableDrawer as Swipeable } from "@mui/material";
import styled from "styled-components";

import color from "../../../../constants/color";
import materialUI from "../../../../material-UI";

export const PopoverContainer = styled.div`
  max-width: 200px;
  font-family: Arial, sans-serif;
  color: #333;
  display: flex;
  flex-direction: column;
`;

// Área de rolagem para a lista de checkboxes
export const ScrollableContent = styled.div`
  padding: 8px 16px;
  max-height: 250px;
  overflow-y: auto; /* Mantém a rolagem vertical */
  overflow-x: hidden; /* Oculta a rolagem horizontal */

  &::-webkit-scrollbar-thumb {
    background-color: #a3a3a6;
    border-radius: 8px;
  }
  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
  }
`;

// Container fixo para os botões Resetar e Salvar
export const ButtonContainer = styled.div`
  display: grid;
  align-items: center;
  border-top: 1px solid #ddd;
`;

// Botão de ação (Resetar e Salvar)
export const ActionButton: any = styled.button`
  text-transform: none;
  font-size: 14px;
  color: #2d5bff;
  background-color: ${(props: any) =>
    props.primary ? "#EAEFFF" : "transparent"};
  border: none;
  cursor: pointer;
  padding: 8px 8px;
`;

export const Title = styled.div`
  font-size: 24px;
  color: ${color.Black};
  font-family: Inter;
`;

export const SizedBox = styled.div`
  margin-top: 32px;
`;
export const Info = styled.div`
  font-size: 14px;
  color: ${color.Black};
  margin: 18px 0px 18px 0px;
  font-family: Inter;
  text-align: center;
`;
export const Space = styled.div`
  height: 18px;
  width: 18px;
`;
export const Img = styled.img``;
export const Table = styled.table`
  height: 32px;
  padding-left: 8px;
  border-spacing: 0;
`;
export const THead = styled.thead`
  height: 32px;
  padding-left: 8px;
`;
export const Tr = styled.tr``;
export const Th = styled.th`
  font-family: Roboto;
  color: #ababab;
  text-align: left;
  height: 32px;
  padding-left: 8px;
  font-weight: normal;
  cursor: pointer;
  border-bottom: 1px solid #e8e8e8;
  &:first-of-type {
    max-width: 28px;
    padding-left: 0;
    @media (max-width: 1880px) {
      margin-right: 8px;
      max-width: 38px;
    }
  }
  .reorder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;

    span {
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .arrowIcon {
      transform: rotateX(180deg);
    }
  }
`;
export const ThLead = styled.th`
  font-family: Roboto;
  color: #ababab;
  text-align: left;
  height: 32px;
  padding-left: 8px;
  font-weight: normal;
  cursor: pointer;
  .reorder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;

    span {
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .arrowIcon {
      transform: rotateX(180deg);
    }
  }
`;
export const ContainerObs = styled.div`
  position: absolute;
  padding: 8px;
  background: ${color.cardBorder};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100%;
  width: 358px;
  z-index: 999999;

  svg {
    min-width: 16px;
    height: 16px;
    margin: unset !important;
    margin-right: 8px !important;
  }
`;
export const TextObs = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #424248;
  overflow: auto !important;
  overflow-x: auto !important;
  text-overflow: unset !important;
  white-space: break-spaces !important;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const FirstFixedTd = styled.td`
  left: 0px;
  z-index: 3;

  height: 32px;

  position: sticky;
  position: -webkit-sticky;
  top: 0;
  background: ${color.White};

  font-family: Inter;
  font-size: 14px;
  color: ${color.Black};
  white-space: nowrap;
  max-width: 170px;
  a {
    text-decoration: none;
    font-family: Inter;
    font-size: 14px;
    color: ${color.Black};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline;
    max-width: 90%;
  }
  &.prodTd {
    .nomeEmp {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &:hover {
      .containerEmp {
        visibility: visible;
        opacity: 1;
      }
    }
  }
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.obsTd {
    padding: 0;

    &:hover {
      .containerObs {
        opacity: 1;
        visibility: visible;
        z-index: 999;
      }
    }

    svg {
      margin: 0 auto;
      display: block;
    }
  }

  &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #ddd;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: #e8e8e8;
  }
`;

export const FirstFixedTh = styled.th`
  padding: 4px 8px;
  white-space: normal;
  word-break: break-word;
  left: 0px;

  z-index: 3;

  position: sticky;
  background: ${color.White};

  font-family: Roboto;
  color: #ababab;
  text-align: left;
  height: 32px;
  padding-left: 8px;
  font-weight: normal;
  cursor: pointer;
  &:first-of-type {
    max-width: 28px;
    padding-left: 0;
    @media (max-width: 1880px) {
      margin-right: 8px;
      max-width: 38px;
    }
  }
  .reorder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;

    span {
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .arrowIcon {
      transform: rotateX(180deg);
    }
  }

  &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #ddd;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: #e8e8e8;
  }
`;

export const SecondFixedTd = styled(FirstFixedTd)`
  left: 33px; // Largura da primeira coluna (checkbox)
  position: sticky;
  z-index: 2;
  padding: 0 8px !important;
  overflow: visible;
  min-width: 130px !important;
  max-width: 130px !important;
  width: 130px !important;
`;

export const SecondFixedTh = styled(FirstFixedTh)`
  left: 33px; // Largura da primeira coluna (checkbox)
  position: sticky;
  z-index: 2;
  padding: 4px 8px !important;
  min-width: 130px !important;
  max-width: 130px !important;
  width: 130px !important;
`;

export const ThirdFixedTd = styled(FirstFixedTd)`
  left: 160px; // 33px (checkbox) + 130px (ações) = 163px
  position: sticky;
  z-index: 1;
`;

export const ThirdFixedTh = styled(FirstFixedTh)`
  left: 160px; // 33px (checkbox) + 115px (ações) = 148px
  font-family: Roboto;
  color: #ababab;
  text-align: left;
  position: sticky;
  z-index: 1;
  height: 32px;
  padding-left: 8px;
  font-weight: normal;
  cursor: pointer;
  .reorder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;

    span {
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .arrowIcon {
      transform: rotateX(180deg);
    }
  }
`;

export const Td = styled.td`
  height: 32px;
  padding-left: 8px;
  font-family: Inter;
  font-size: 14px;
  color: ${color.Black};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 170px;
  border-bottom: 1px solid #e8e8e8;
  a {
    text-decoration: none;
    font-family: Inter;
    font-size: 14px;
    color: ${color.Black};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline;
    max-width: 90%;
  }
  &.prodTd {
    .nomeEmp {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &:hover {
      .containerEmp {
        visibility: visible;
        opacity: 1;
      }
    }
  }
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.obsTd {
    padding: 0;
    position: relative;
    overflow: unset;

    &:hover {
      .containerObs {
        opacity: 1;
        visibility: visible;
        z-index: 999;
      }
    }

    svg {
      margin: 0 auto;
      display: block;
    }
  }
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  // não permitindo a seleção
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  min-height: calc(100vh - 240px);
`;
export const ImgCheck = styled.img`
  width: 14px;
  margin-right: 8px;
  margin-top: 4px;
`;
export const Nav = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: white;
  margin-bottom: 8px;
`;
export const ShowTotalText = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${color.primary};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
export const ContentSearch = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const OnPress = styled.div`
  height: 36px;
  min-width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #e0e0e0;
  width: 36px;
  position: relative;
  cursor: pointer;

  :hover {
    background-color: ${color.ice};
  }
`;

export const FiltersCount = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: ${color.error};
  width: 16px;
  height: 16px;
  border-radius: 100%;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const OnClick = styled.a`
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-width: 14px;
`;
export const MenuItem = styled(materialUI.MenuItem)`
  font-family: Inter;
  font-size: 14px;

  &.Mui-disabled {
    opacity: 0.5;
  }
`;

export const Checkbox = styled(materialUI.Checkbox)``;
export const Menu = styled(materialUI.Menu)``;
export const ContainerInput = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 0px 6px;
  margin-right: 2px;
  min-width: 340px;
  padding-right: 0;
  height: 36px;
  display: flex;
  align-items: center;
`;

export const ContainerPagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
  margin-left: 0px;
  margin-bottom: 20px;
  margin-right: 0px;
`;
export const Select = styled(materialUI.Select)`
  padding-left: 4px;
  margin-left: 10px;
  color: #46505a;
  border: 1px solid #c6ccd7;
  border-radius: 16px;
  height: 32px;

  legend {
    span {
      display: none;
    }
  }
`;
export const Arrow = styled.div`
  display: flex;
  width: 25px;
  justify-content: center;
  align-items: center;
  height: 25px;
  margin: 0px 4px 0px 4px;
  background-color: ${color.grey6};
  border-radius: 30px;
`;
export const Arrows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  li {
    button {
      background: #f2f4f8;
      color: #819dff;
      border: none;
      width: 26px;
      height: 26px;
    }
    .Mui-selected {
      background-color: #819dff;
      color: #ffffff;
      border-radius: 3px;
    }
  }
`;

export const TransferComponent = styled.div`
  padding: 24px;
  padding-top: 0;
  height: 500px;
`;

export const MultLineField = styled.div`
  position: relative;
  margin-top: 26px;
`;

export const CountText = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #a3a3a6;
  position: absolute;
  right: 14px;
  bottom: 10px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
`;
export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;
export const Button = styled(materialUI.Button)`
  width: 170px;
  height: 43px;
  border-radius: 8px;
  border: 1px solid ${color.Mediumgrey};
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter-Medium;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: ${color.Black};
  }
  &.transfer-btn {
    background-color: ${color.primary};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border: 1px solid ${color.primary};
    span {
      color: ${color.white};
    }
  }
  &.error-btn {
    background-color: ${color.error};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border: 1px solid ${color.error};
    span {
      color: ${color.white};
    }
  }
`;
export const FooterTransfer = styled.div`
  margin-top: 26px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
export const NotFoundText = styled.p`
  width: 100%;
  text-align: center;
  padding: 50px;
  font-size: 16px;
  color: ${color.Almostblack};
  font-family: Inter;
`;
export const SelectAllBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 4px;
  font-family: Inter;
  font-size: 13px;
  color: ${color.Almostblack};
`;

export const SelectAllBannerButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  color: #2d5bff;
  text-decoration: underline;
`;

export const PositionIcon = styled(materialUI.InputAdornment)``;

export const Autocomplete = styled(materialUI.Autocomplete)``;

export const SwipeableDrawer = styled(Swipeable)`
  .MuiDrawer-paperAnchorRight {
    width: 392px;
    border-radius: 8px 0px 0px 8px;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${color.Mediumgrey};
    }
  }
`;

export const LinkRef = styled.a`
  padding-left: 8px;
  text-decoration: none;
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
`;

export const ContainerEmp = styled.span`
  position: absolute;
  bottom: 120%;
  left: -50%;
  background: ${color.white};
  border: 1px solid ${color.cardBorder};
  box-shadow: 0px 2px 62px rgba(102, 102, 102, 0.2);
  border-radius: 8px;
  width: 312px;
  max-height: 233px;
  transition: all 0.3s;
  visibility: hidden;
  opacity: 0;
  z-index: 999;
`;

export const HeaderContainer = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.01em;
  color: ${color.white};
  padding: 16px 14px;
  border-bottom: 1px solid ${color.cardBorder};
`;

export const ContentEmp = styled.ul`
  padding: 4px 16px 16px 16px;
  overflow: hidden;
  overflow-y: auto;
  max-height: 170px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.Mediumgrey};
  }

  li {
    display: flex;
    align-items: center;
    list-style: none;
    margin-top: 12px;
    p {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.05em;
      color: ${color.white};
      margin-left: 5px;
    }
  }
`;

export const BtnSearch = styled(materialUI.Button)`
  height: 36px;
  width: 36px;
  min-width: auto;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border: none;

  &:hover {
    background: transparent;
    box-shadow: none;
    border: none;
  }

  &.Mui-disabled {
    background: transparent;
    box-shadow: none;
    border: none;
  }
`;

export const NavTable = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const RowReverse = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;

export const ButtonEtapa = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: transparent;
  border: none;
  :disabled {
    cursor: default;
  }
`;

export const UpdateButton = styled.button`
  background-color: ${color.primary};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 6px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  transition: all 0.3s;
  white-space: nowrap;
  height: 28px;
  flex-shrink: 0;
  width: 88px;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    display: block;
  }

  &:hover {
    background-color: ${color.Primaryv1};
  }

  &:active {
    transform: scale(0.98);
  }
`;

// Área que recebe o overlay de carregamento durante um refetch (filtro,
// busca, paginação). Mantém a tabela visível por baixo para não haver
// "salto" de layout.
export const LoadingArea = styled.div`
  position: relative;
  width: 100%;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 80px;

  background: rgba(255, 255, 255, 0.7);
  cursor: progress;
`;

export const LoadingOverlayContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 12px 20px;

  background: ${color.White};
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);

  font-family: Inter;
  font-size: 14px;
  color: ${color.Black};
  white-space: nowrap;
`;
